module.exports = __webpack_public_path__ + "static/together1-dad6eb15d7bbaecbc4bfe9c6db0dd877.png";